/*!
 * Copyright (c) REWE Digital GmbH
 */
import { MDCDialog } from "@material/dialog";
import { Host, h } from "@stencil/core";
/**
 * Shared component from dialog.
 */
export class VxModal {
    constructor() {
        this.inView = false;
        this.sizingX = 'auto';
    }
    /**
     * Component Loader function.
     */
    componentDidLoad() {
        this.dialog = new MDCDialog(this.host.querySelector('.mdc-dialog'));
        this.dialog.listen('MDCDialog:opened', () => this.inViewToggled.emit(true));
        this.dialog.listen('MDCDialog:closed', () => this.inViewToggled.emit(false));
    }
    /**
     * Calls the modals open or close functions based on the modals state.
     *
     * @param {boolean} state Is the modal visible or not.
     */
    async toggleInView(state) {
        if (state) {
            await this.open();
        }
        else {
            await this.close();
        }
    }
    /**
     * Calls the material-ui dialogs open method.
     */
    async open() {
        this.dialog.open();
    }
    /**
     * Calls the material-ui dialogs close method.
     */
    async close() {
        this.dialog.close();
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} The rendered component.
     */
    render() {
        return (h(Host, { key: '67f69a1cde0f49a2c9a276d548c44785df6dc4e3' }, h("div", { key: '9895ca0826e485e1b416d7888f14ad325d807e33', class: "mdc-dialog mdc-dialog--sm", "data-sizingX": this.sizingX }, h("div", { key: '4318a465850ca532b4e09079a71479247dff51fa', class: "mdc-dialog__container" }, h("div", { key: '6d0f30b646a0b3f845a2adba311a98122606aaad', class: "mdc-dialog__surface", role: "alertdialog", "aria-modal": "true", "aria-labelledby": "my-dialog-title", "aria-describedby": "my-dialog-content" }, h("div", { key: 'cfac8f2b6e8ce2d36bbbdbb04c8101bcb068ca05', class: "mdc-dialog__header" }, h("slot", { key: '7588a1325a8aa9f1de58ae33c41ef4a9d39fd37a', name: "headline" }), h("button", { key: '5dabea885d34d5270664a1cf73b4516d7c724e6a', class: "mdc-dialog__close", "data-mdc-dialog-action": "close" }, h("vx-icon", { key: 'abb6daa03561732d78cca8a38d88f3ec7ca371f0', icon: "close", customClass: 'reinvert' }))), h("div", { key: 'e19ff81eb9a679a52da95cfb458ccbd08a3ec121', class: "mdc-dialog__content", id: "my-dialog-content" }, h("slot", { key: '81e58d6bad4bf67a09e6385e62fcd08962bfa730', name: "content" })))), h("div", { key: 'd19881b6dc4af934c1a87f2ac28959577c82b418', class: "mdc-dialog__scrim" }))));
    }
    static get is() { return "vx-modal"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-modal.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-modal.css"]
        };
    }
    static get properties() {
        return {
            "inView": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Property that tells you if the modal is visible or not."
                },
                "attribute": "in-view",
                "reflect": false,
                "defaultValue": "false"
            },
            "sizingX": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Possible values: auto | fixed.\nControls if width of modal is controlled by the content or set to fixed width."
                },
                "attribute": "sizing-x",
                "reflect": false,
                "defaultValue": "'auto'"
            }
        };
    }
    static get events() {
        return [{
                "method": "inViewToggled",
                "name": "inViewToggled",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Event-emitter to notify when the visibility of the modal changes."
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "open": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Calls the material-ui dialogs open method.",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Calls the material-ui dialogs close method.",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "host"; }
    static get watchers() {
        return [{
                "propName": "inView",
                "methodName": "toggleInView"
            }];
    }
}
//# sourceMappingURL=vx-modal.js.map
